import { render, staticRenderFns } from "./DemoForm.vue?vue&type=template&id=d1cb7444"
import script from "./DemoForm.vue?vue&type=script&lang=js"
export * from "./DemoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports